import { ENDPOINT as getHeatMapActivityDuration } from 'api/endPoints/getHeatMapActivityDuration';
import { ENDPOINT as getHeatMapActivityStart } from 'api/endPoints/getHeatMapActivityStart';
import { ENDPOINT as getHeatMapActivityStartOrFinish } from 'api/endPoints/getHeatMapActivityStartOrFinish';
import { ENDPOINT as getHeatMapResources } from 'api/endPoints/getHeatMapResources';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { LARGE_SHORT, MEDIUM_SHORT } from 'components/Dashboards/Reporting/reportingConfig';

export const riskHeatMap: IHashmapItemComponentProps = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'wbs', name: 'wbs', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
    ],
    id: 'RiskDensityByActivityStarts',
    componentKey: 'riskHeatMap',
    title: 'Criticality Heatmap',
    reportStyle: {
        widgetSizesAvailable: {
            mediumShort: MEDIUM_SHORT,
            largeShort: LARGE_SHORT,
        },
        widgetInitialSize: MEDIUM_SHORT,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: true,
        },
        hideNarrativeEditor: true,
    },
    endpoint: {
        heatMapActivityStartOrFinish: getHeatMapActivityStartOrFinish,
        heatMapActivityDuration: getHeatMapActivityDuration,
        heatMapActivityStarts: getHeatMapActivityStart,
        heatMapActivityResources: getHeatMapResources,
    },
};
